import { ReactElement, Suspense } from "react";
import { Await } from "react-router-dom";
import { AuthorContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import Spinner from "@components/Spinner/Spinner";
import { useContext } from "@util/getContext";

import AuthorPageContent from "./AuthorPageContent";

export default function AuthorPage(): ReactElement {
  const context: AuthorContext = useContext();

  return (
    <Suspense fallback={<Spinner />}>
      <Await resolve={context} errorElement={<CustomError />}>
        {({ kind, error, data }) => {
          return kind !== "author" || error ? (
            <h1>Missing context</h1>
          ) : (
            <AuthorPageContent data={data} />
          );
        }}
      </Await>
    </Suspense>
  );
}
